import Regia81 from '../../../media/SCG/Regia/8/Regia 8.webp'
import Regia82 from '../../../media/SCG/Regia/8/Regia 8 D.webp'
import Regia83 from '../../../media/SCG/Regia/8/Regia 8 P.webp'


const Regia8images =[
Regia81,Regia82,,Regia83
]

export default Regia8images;